<template>
<ul class="list list-event">
  <li v-for="perfData in performanceData" :key="perfData.objId" :style="{borderColor: perfData.eventlevelColor}">
    <span v-for="field in SVC_ELEMENT_TYPE[perfData.elementType]" :key="field.index">
      {{ perfData[field] }}
    </span>
    <span v-if="perfData.status && perfData.elementType !== 'DBMS'">
      <b>운영상태</b> {{ setElementStatusLabel(perfData.status) }}
    </span>
    <span v-for="rscInfo in perfData.rscInfos" :key="`${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
      <b>{{ rscInfo.rscName }}</b>
      {{ rscInfo.rscId === 'AP_STATUS' ? getApStatusName(rscInfo.rscValue) : convertValuByUnit(getValueAfterCheckEmpty(rscInfo.rscValue), rscInfo.rscUnit, true, true, false) }}
    </span>
    <span v-if="perfData.elementType === 'E2E_SERVICE'">
      E2E 에이전트 정보 [
    </span>
    <div v-for="agentInfo in perfData.agentInfos" :key="agentInfo.index" style="display: contents">
      <span><b>{{ agentInfo.objName }}</b></span>
      <span style="background: none">(</span>
      <span><b>운영상태</b> {{ setElementStatusLabel(agentInfo.status) }}</span>
      <span v-for="rscInfo in agentInfo.rscInfos" :key="`${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
        <b>{{ rscInfo.rscName }}</b> {{ convertValuByUnit(rscInfo.rscValue, rscInfo.rscUnit, true, true, false) }}
      </span>
      <span>)</span>
    </div>
    <span v-if="perfData.elementType === 'E2E_SERVICE'">
      ]
    </span>
  </li>
</ul>
</template>

<script>
import { SVC_ELEMENT_TYPE } from '@/constants/objdefine';
import { convertValuByUnit } from '@/utils/number';
import { getApStatusName } from '@/utils/wireless-device';
import { getValueAfterCheckEmpty } from '@/utils/string';

export default {
  name: 'WPerformanceList',
  props: {
    performanceData: {
      type: Array,
    },
  },
  data() {
    return {
      SVC_ELEMENT_TYPE,
    };
  },
  methods: {
    convertValuByUnit,
    getValueAfterCheckEmpty,
    getApStatusName,
    /**
     * element 의 접속상태를 UP, DOWN 라벨로 표현
     * @author jeee12
     * @param  {Boolean} status 접속상태 value
     */
    setElementStatusLabel(status) {
      if (status === '1') {
        return 'UP';
      } else if (status === '0') {
        return 'DOWN';
      }
      return '-';
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/components/PerformanceList.vue